import { render, staticRenderFns } from "./StokEkstreSozlesmeler.vue?vue&type=template&id=1ed53ff7&"
import script from "./StokEkstreSozlesmeler.vue?vue&type=script&lang=js&"
export * from "./StokEkstreSozlesmeler.vue?vue&type=script&lang=js&"
import style0 from "./StokEkstreSozlesmeler.vue?vue&type=style&index=0&id=1ed53ff7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports